<pcs-modal>
  <pcs-modal-header>
    <h5 class="modal-title">{{titleText | translate}}</h5>
    <pcs-icon icon="close" aria-label="Close" (click)="onClose()" size="iconM"></pcs-icon>
  </pcs-modal-header>
  <pcs-modal-body>
    <p>{{getMessage(props)}}</p>
  </pcs-modal-body>
  <pcs-modal-footer>
    <pcs-button [buttonText]="cancelButtonText"
                (clicked)="onClose()"
                buttonSize="small"></pcs-button>
    <pcs-button [buttonText]="buttonText"
                [buttonStyle]="props.componentStyle"
                (clicked)="onConfirm()"
                buttonSize="small"></pcs-button>
  </pcs-modal-footer>
</pcs-modal>
